import { Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { WMSInput } from "../../widgets/input";
import { DateRangePicker } from "react-date-range";
import { apiUrl } from "../../base/utils";
import { invokeGetService } from "../../service";
import { WMSSelect } from "../../widgets/selectbox";
import WHSLoader from "../../widgets/loader";
import NofoundLoader from "../../widgets/nofound";
import { connect } from "react-redux";
import { subMonths } from "date-fns";
import HOCAutoLogout from "../autologout";

const formatDate = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "2-digit",
    year: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
};

function Dashboard(props: any) {
  const [isLoader, setLoader] = useState(false);
  const [dateShow, setDateShow] = useState(true);
  const [articlename, setArticleName] = useState("");
  const [dateRange, setDateRange] = useState([
    {
      startDate: subMonths(new Date(), 1),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [authorOptions, setAuthorOptions] = useState([]);
  const [articleOptions, setArticleOptions] = useState([]);
  const [authorName, setAuthorName] = useState<any>(null);
  const [articleId, setArticleID] = useState<any>(null);
  const [articleDetails, setArticleDetails] = useState<any>("");
  const [historydata, setHistoryData] = useState<any>({});
  const timeSlide = useRef<HTMLDivElement>(null);
  const [intialArticles, setInitialArticles] = useState([]);
  const [inputDate, setInputDate] = useState(() => {
    const endDate = new Date();
    const startDate = subMonths(endDate, 1);
    return `${formatDate(startDate)} to ${formatDate(endDate)}`;
  });

  const getDashboardInfo = async (type?: any) => {
    try {
      setDateShow(!dateShow);
      const startoriginalDate = new Date(dateRange[0].startDate);
      const endoriginalDate = new Date(dateRange[0].endDate);
      const start = startoriginalDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      const end = endoriginalDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      setLoader(true);
      const queryParams = { startDate: start, endDate: end };
      // const queryParams = { startDate: startDate.substring(0, 10), endDate: endDate.substring(0, 10) }
      let url = apiUrl.nodeApi.getArticleListForDashboard;
      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );
      setLoader(false);
      let authornameOptions: any = [];
      let articleOptions: any = [];
      if (response.data.isSuccess) {
        response.data.result.articles.map((list: any) => {
          authornameOptions.push({
            value: list.authorname,
            label: list.authorname,
            id: list.articleid,
          });
        });
        response.data.result.articles.map((list: any) => {
          articleOptions.push({
            value: list.name,
            label: list.name,
            id: list.articleid,
          });
        });
      }
      if (!response.data.isSuccess) throw new Error(response.data.data.Error);
      setAuthorOptions(authornameOptions);
      setArticleOptions(articleOptions);
      setInitialArticles(articleOptions);
      setArticleDetails(response.data.result.metrix);
    } catch (error) {
      setLoader(false);
    }
  };
  const handleFormSelection = (e: any, type: any) => {
    if (type === "authorname") {
      setAuthorName(e);
      setArticleOptions(intialArticles.filter((list: any) => list.id == e.id));
      setArticleID(e);
    } else {
      setArticleID(e);
    }
  };

  const handleFilterDashboard = async () => {
    try {
      const startoriginalDate = new Date(dateRange[0].startDate);
      const endoriginalDate = new Date(dateRange[0].endDate)
      const start = startoriginalDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      const end = endoriginalDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      let url = apiUrl.nodeApi.getArticleStageHistory;
      const queryParams = { articleId: articleId.id, startDate: start.replaceAll('/', '-'), endDate: end.replaceAll('/', '-') }
      setArticleName(articleId.value);
      setLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );
      setHistoryData(response.data.result);
      setLoader(false);
      if (!response.data.isSuccess) throw new Error(response.data.data.Error);
      
      // Remove this code that resets the date range
      // setDateRange([
      //   {
      //     startDate: new Date(),
      //     endDate: new Date(),
      //     key: "selection",
      //   },
      // ]);
    } catch (error) {
      setLoader(false);
    }
  };


  const selectionDatePicker = (ranges: any) => {
    setDateRange([ranges.selection]);
    const originalEndDate = new Date(ranges.selection.endDate);
    const endDate = formatDate(originalEndDate); // Format end date
    const originalStartDate = new Date(ranges.selection.startDate);
    const startDate = formatDate(originalStartDate); // Format start date
    setInputDate(`${startDate} to ${endDate}`);
  };

  const sliderAction = (type: string) => {
    let divWith: any = timeSlide?.current?.scrollWidth;
    let toolTotalWidth: any = timeSlide?.current?.scrollLeft;
    if (type === "left") {
      if (toolTotalWidth - 260 >= divWith) {
        timeSlide?.current?.scrollTo(divWith, 0);
      } else {
        timeSlide?.current?.scrollTo(toolTotalWidth - 260, 0);
      }
    } else {
      if (toolTotalWidth + 260 <= 0) {
        timeSlide?.current?.scrollTo(0, 0);
      } else {
        timeSlide?.current?.scrollTo(toolTotalWidth + 260, 0);
      }
    }
  };

  const inputClick = () => {
    setDateShow(!dateShow);
  };

  const handleModalCancel = () => {
    setDateShow(!dateShow);
    setDateRange([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
  };

  useEffect(() => {
    if (dateRange.length > 0) {
      getDashboardInfo();
    }
  }, []);

  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}
      <div className="page-title">
        <h3>Dashboard</h3>
        <div className="dashboard-top-filter">
          <label style={{ position: "relative" }}>Filter by</label>
          <div className="col-lg-4 datePicker-in">
            <WMSInput
              type="text"
              placeHolder="week"
              className="form-control bg-white"
              value={inputDate}
              readOnly={true}
              onClick={inputClick}
              id="search-table"
            />
            <span className="material-icons" onClick={inputClick}>
              event
            </span>
          </div>
          {dateShow ? (
            <div className="dateRanger-picker">
              <DateRangePicker
                ranges={dateRange}
                maxDate={new Date()}
                onChange={(item: any) => selectionDatePicker(item)}
                className="w-100"
              />
              <div className="date-footer">
                <Button className="btn btn-primary" onClick={getDashboardInfo}>
                  APPLY
                </Button>
                <Button
                  className="ml-3"
                  variant="outline-secondary"
                  onClick={handleModalCancel}
                >
                  CANCEL
                </Button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <div className="box-inner">
            <h5>Article Submission Status</h5>
            <div className="status-bar">
              <div>
                <p>Submission Completed</p>
                <label>
                  {articleDetails.subcompleted === undefined
                    ? 0
                    : articleDetails.subcompleted}
                </label>
              </div>
              <div>
                <p>Submission Pending</p>
                <label>
                  {articleDetails.subpending === undefined
                    ? 0
                    : articleDetails.subpending}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box-inner">
            <h5>Article Status</h5>
            <div className="status-bar">
              <div>
                <p>Accepted</p>
                <label>
                  {articleDetails.accepted === undefined
                    ? 0
                    : articleDetails.accepted}
                </label>
              </div>
              <div>
                <p>Pending</p>
                <label>
                  {articleDetails.pending === undefined
                    ? 0
                    : articleDetails.pending}
                </label>
              </div>
              <div>
                <p>Reject</p>
                <label>
                  {articleDetails.rejected === undefined
                    ? 0
                    : articleDetails.rejected}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h5>Timeline</h5>
        <div className="d-flex">
          <div
            style={{
              width: "200px",
              marginRight: "16px",
              position: "relative",
              zIndex: "8",
            }}
          >
            <WMSSelect
              className="form-control"
              placeHolder="Select Article ID"
              options={articleOptions}
              name="fileTypes"
              value={articleId}
              isMulti={false}
              onChange={(e: any) => {
                handleFormSelection(e, "articleid");
              }}
              id="articleid"
            />
          </div>
          <Button disabled={!inputDate} onClick={handleFilterDashboard}>
            APPLY
          </Button>
        </div>
      </div>
      <div className="mt-4">
        <div className="d-flex" style={{ justifyContent: "space-between" }}>
          <h5>Article {articlename}</h5>
          <div>
            <ul className="legend-top">
              <li>
                <p>Completed</p>
              </li>
              <li>
                <p>In Progress</p>
              </li>
              {/* <li><p>Yet to start</p></li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="timeline-area" ref={timeSlide}>
        {Object.keys(historydata).length > 0 ? (
          Object.keys(historydata).map((list: any, i: any) => {
            let arrayItem = historydata[list];
            const dateArray = list.split("-");
            return (
              <div key={i} className="timeline-area-group">
                <div className="timeline-head">
                  <h5>{dateArray[0]}</h5>
                  <p>
                    {dateArray[1]} {dateArray[2]}
                  </p>
                  <div className="ytsstatus"></div>
                </div>
                {arrayItem.map((list: any, j: any) => (
                  <div key={j} className="timeline-list">
                    <span>
                    {list.name}
                    {" currently with "}
                    <span style={{fontWeight: 'bolder'}}>{list.responsibility}</span>
                    </span>
                    {/* <p>{list.name}</p>
                    <p>{"Currently with"}</p>
                    <strong>{list.responsibility}</strong> */}
                  </div>
                ))}
              </div>
            );
          })
        ) : (
          <NofoundLoader />
        )}
      </div>
      <div className="slide-nav-button">
        <Button onClick={() => sliderAction("left")}>
          {" "}
          <span className="material-icons">chevron_left</span>
        </Button>
        <Button onClick={() => sliderAction("right")}>
          <span className="material-icons">chevron_right</span>
        </Button>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    // isFileUpload:state.rootReducer.articleReducer.fileUpload
  };
};

export default connect(mapStateToProps, null)(HOCAutoLogout(Dashboard));
